import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategorySection() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            特色栏目专区
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            精选六大特色栏目，涵盖每日大赛、台北娜娜、莫里秀、玩偶姐姐等热门分类
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-4 md:p-5 bg-background-50 rounded-lg border border-background-200/60 hover:border-rose-200 hover:shadow-sm transition-all duration-300 cursor-pointer"
            >
              <div
                className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-gradient-to-br ${cat.color} mb-3 group-hover:scale-110 transition-transform duration-300`}
              >
                <i className={`${cat.icon} text-white text-lg md:text-xl`}></i>
              </div>
              <span className="text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500 mt-1 line-clamp-1 text-center">
                {cat.description.slice(0, 15)}...
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}